import { type Routes } from '@angular/router';

import { authGuard } from '@core/auth/auth.guard';
import { dashboardVisible } from '@shared/dashboards/dashboard-registry';

export const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./layout/app-shell/app-shell.component').then((module) => module.AppShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        title: 'Дашборды — Васта: Аналитика',
        loadComponent: () =>
          import('./features/home/home.component').then((module) => module.HomeComponent),
      },
      {
        path: 'dashboards/restaurant-flash',
        title: 'Restaurant Flash — Васта: Аналитика',
        loadComponent: () =>
          import('./features/dashboards/restaurant-flash/restaurant-flash-dashboard.component').then(
            (module) => module.RestaurantFlashDashboardComponent,
          ),
      },
      {
        path: 'dashboards/aquapark-flash',
        title: 'Aquapark Flash — Васта: Аналитика',
        canMatch: [dashboardVisible],
        loadComponent: () =>
          import('./features/dashboards/aquapark-flash/aquapark-flash-dashboard.component').then(
            (module) => module.AquaparkFlashDashboardComponent,
          ),
      },
      {
        path: 'dashboards/manager-flash',
        title: 'Manager Flash — Васта: Аналитика',
        loadComponent: () =>
          import('./features/dashboards/manager-flash/manager-flash-dashboard.component').then(
            (module) => module.ManagerFlashDashboardComponent,
          ),
      },
    ],
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    title: 'Личный кабинет — Васта: Аналитика',
    loadComponent: () =>
      import('./features/profile/profile.component').then((module) => module.ProfileComponent),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
